const queryReducer = (state, action) => {
  switch (action.type) {
    case "update":
      if (action.queryValue) {
        return {
          ...state,
          ...action.queryValue,
        }
      }

      return state
    case "remove":
      if (action.queryValue && state) {
        action.queryValue.map(x => delete state[x])

        return state
      }
      return state
    case "resurrect":
      return action.query
    case "reset":
      return {}
    default:
      break
  }
}

export default queryReducer
